/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { ConversionRatesDto } from '../dto';

export const ConversionRatesMapper = entity<ConversionRatesDto>({});
